import { render, staticRenderFns } from "./Messages.html?vue&type=template&id=3dd5c57a&"
import script from "./Messages.js?vue&type=script&lang=js&"
export * from "./Messages.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports